/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * moovy-saas-api
 * OpenAPI spec version: 1.0.0
 */
import type { Cuid, PublicTenant } from '.././model'

import getPublicTenantMutator from '../../../customFetch'

/**
 * テナント情報を取得
指定されたテナントの公開情報を取得します。
 */
export const getPublicTenant = (tenantId: Cuid) => {
  return getPublicTenantMutator<PublicTenant>({ url: `/public/tenants/${tenantId}`, method: 'GET' })
}
export type GetPublicTenantResult = NonNullable<Awaited<ReturnType<typeof getPublicTenant>>>
